import React, { useState } from 'react'
import { Box, CardMedia, Stack, IconButton } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import SwipeableViews from 'react-swipeable-views'

type TContainerOrderItem = {
  name: string
  images: string[]
  refNo?: string
  price: number
  maker: string
  carName: string
  modelCode: string
}

interface IContainerOrderItemMediaProps {
  data: TContainerOrderItem
}

/**
 * ContainerOrderItemMedia
 *
 * @param __namedParameters IContainerOrderItemMediaProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const ContainerOrderItemMedia: React.FC<IContainerOrderItemMediaProps> = ({
  data,
}): JSX.Element => {
  const { images } = data
  const imagesCount: number = images.length
  const [carouselIndex, setCarouselIndex] = useState<number>(0)

  const handleChangeCarousel = (index: number) => {
    setCarouselIndex(index)
  }

  const prevCarousel = () => {
    setCarouselIndex(carouselIndex === 0 ? imagesCount - 1 : carouselIndex - 1)
  }

  const nextCarousel = () => {
    const carouselImageIndexCount = carouselIndex + 1
    setCarouselIndex(carouselImageIndexCount === imagesCount ? 0 : carouselIndex + 1)
  }

  return (
    <Box sx={{ marginRight: '20px', width: '390px' }}>
      <SwipeableViews
        className="carousel"
        enableMouseEvents
        resistance
        animateHeight
        index={carouselIndex}
        onChangeIndex={(index: number) => handleChangeCarousel(index)}
      >
        {images.map((imageSrc: string, index: number) => (
          <CardMedia
            key={index}
            component="img"
            height="260"
            width="390"
            image={imageSrc}
            alt={data.name}
            sx={{
              minWidth: '390px',
            }}
          />
        ))}
      </SwipeableViews>
      <Stack direction="row" spacing={1} marginTop={2}>
        <IconButton
          aria-label="prev"
          sx={{
            width: '24px',
            height: '24px',
            color: '#fff',
            background: '#222',
          }}
          onClick={prevCarousel}
        >
          <ArrowBackIosNewIcon sx={{ width: '16px', height: '16px' }} />
        </IconButton>
        <Box sx={{ paddingTop: '6px', fontSize: '11px', color: '#000000' }}>
          {carouselIndex + 1}/{imagesCount}
        </Box>
        <IconButton
          aria-label="next"
          sx={{
            width: '24px',
            height: '24px',
            color: '#fff',
            background: '#222',
          }}
          onClick={nextCarousel}
        >
          <ArrowForwardIosIcon sx={{ width: '16px', height: '16px' }} />
        </IconButton>
      </Stack>
    </Box>
  )
}
